<template>
  <div
    v-if="debugModalShown"
    class="z-50 fixed inset-4 flex flex-col justify-start items-start gap-2 bg-white shadow-md p-2 border rounded-sm max-h-[95vh] overflow-y-auto"
  >
    <div>
      <h2 class="w-full">
        General
      </h2>
      <div class="flex flex-row flex-wrap gap-2">
        <UButton
          to="/"
          size="sm"
          label="Frontpage"
        />

        <UButtonGroup size="sm">
          <UButton
            to="/confirm-email?email=niklas@anima.no"
            label="Confirm email"
          />
          <UButton
            to="/claims?email_confirmed"
            :external="true"
            label="(success)"
          />
        </UButtonGroup>
        <UButton
          to="/claims"
          size="sm"
          label="Claims"
        />
        <UButton
          to="/questions"
          size="sm"
          label="Questions"
        />
        <UButton
          to="/share"
          size="sm"
          label="Share"
        />
        <UButton
          to="/thanks"
          size="sm"
          label="Thanks"
        />
        <UButton
          to="/unsubscribe"
          size="sm"
          label="Unsubscribe (no change)"
        />
      </div>
    </div>
    <div>
      <h2 class="w-full">
        Organisations
      </h2>
      <div class="flex flex-row flex-wrap gap-2">
        <UButton
          to="/org/contact"
          size="sm"
          label="Write to company"
        />
        <!-- <UButton
          to="/org/feedback"
          size="sm"
          label="Feedback"
        /> -->
      </div>
    </div>
    <div>
      <h2 class="w-full">
        People
      </h2>
      <div class="flex flex-row flex-wrap gap-2">
        <UButton
          to="/people"
          size="sm"
          label="List of people"
        />
        <UButton
          to="/people/district"
          size="sm"
          label="District"
        />
        <UButton
          to="/people/choose"
          size="sm"
          label="Choose people"
        />
        <UButton
          to="/people/contact"
          size="sm"
          label="Write to people"
        />
      </div>
    </div>
    <div>
      <h2 class="w-full">
        Donate
      </h2>
      <div class="flex flex-row flex-wrap gap-2">
        <UButton
          to="/donate"
          label="Donate"
          size="sm"
        />
        <UButton
          to="/donate?first_name=Gunnar&last_name=Gunarson&email=example@example.com&amount=222&recurring=true&donate-success"
          :external="true"
          label="Success"
          size="sm"
        />
        <UButton
          to="/donate?donate-error"
          :external="true"
          label="Error"
          size="sm"
        />
        <UButton
          to="/donate/nin"
          size="sm"
          label="NIN"
        />
      </div>
    </div>
    <div>
      <h2 class="w-full">
        Switch
      </h2>
      <div class="flex flex-row flex-wrap gap-2">
        <UButton
          size="sm"
          label="active_donor"
          @click="user.active_donor = !user.active_donor"
        />
        <UButton
          size="sm"
          label="recent_donation"
          @click="user.recent_donation = !user.recent_donation"
        />
        <UButton
          size="sm"
          label="has_nin"
          @click="user.has_nin = !user.has_nin"
        />
        <UButton
          size="sm"
          label="email_confirmed"
          @click="user.email_confirmed = !user.email_confirmed"
        />
      </div>
    </div>
    <div>
      <h2 class="w-full">
        Return
      </h2>
      <div class="flex flex-row flex-wrap gap-2">
        <UButton
          size="sm"
          label="confirm-email"
          :to="`/return?p=confirm-email&id=${user.auth_id}&utm_source=mautic&utm_medium=email_flow&utm_campaign=turbokylling.no&utm_content=turbokylling_website_flow_1_1`"
        />
        <UButton
          to="/?return-error"
          size="sm"
          label="return-error"
        />
        <UButton
          size="sm"
          label="questions"
          :to="`/return?p=questions&id=${user.auth_id}`"
        />
        <UButton
          size="sm"
          label="contact-org"
          :to="`/return?p=contact-org&id=${user.auth_id}`"
        />
        <UButton
          size="sm"
          label="contact-people"
          :to="`/return?p=contact-people&id=${user.auth_id}`"
        />
        <UButton
          size="sm"
          label="share"
          :to="`/return?p=share&id=${user.auth_id}`"
        />
        <UButton
          size="sm"
          label="thanks"
          :to="`/return?p=thanks&id=${user.auth_id}`"
        />
        <UButton
          size="sm"
          label="donate"
          :to="`/return?p=donate&id=${user.auth_id}`"
        />
        <UButton
          size="sm"
          label="nin"
          :to="`/return?p=nin&id=${user.auth_id}`"
        />
      </div>
    </div>
    <div>
      <h2 class="w-full">
        Tools
      </h2>
      <div class="flex flex-row flex-wrap gap-2">
        <UButton
          size="sm"
          label="Clear timestamps"
          @click="user.timestamp_pages = ''"
        />
        <UButton
          size="sm"
          label="Clear share"
          @click="user.done_sharing = ''"
        />
        <UButton
          size="sm"
          label="Clear questions"
          @click="() => { user.questions = ''; user.opinion = ''; }"
        />
        <UButton
          size="sm"
          label="Reset user"
          @click="user.resetUser()"
        />
        <!-- @click="clearWebCookies" -->
        <UButton
          size="sm"
          label="Show cookie banner"
          @click="clearConsentCookie"
        />
        <UButton
          size="sm"
          label="Clear UTMs"
          @click="clearUTM"
        />
        <UButton
          size="sm"
          label="Add test query"
          @click="navigateTo({ query: { is_test: 'true' } })"
        />
        <div class="flex flex-row gap-1">
          <UInput
            v-model="user.auth_id"
            label="auth_id"
            size="sm"
            class="min-w-[300px]"
          />
          <UButton
            size="sm"
            label="Get user"
            @click="user.getUser(user.auth_id!)"
          />
        </div>
      </div>
    </div>

    <pre class="text-12 leading-tight">user: {{ storeToRefs(user) }}</pre>
    <!-- <pre class="text-12 leading-tight">cookies: {{ storeToRefs(cookies) }}</pre> -->
  </div>
</template>

<script lang="ts" setup>
import { storeToRefs } from 'pinia'

const debugModalShown = ref(false)

const user = useUserStore()
const cookies = useConsentStore()

const clearConsentCookie = () => {
  cookies.show_cookie_banner = true
}

function clearUTM() {
  user.utm_source = undefined
  user.utm_medium = undefined
  user.utm_campaign = undefined
  user.utm_content = undefined
  user.utm_term = undefined
}

if (import.meta.dev) {
  defineShortcuts({
    alt_d: {
      handler: () => {
        debugModalShown.value = !debugModalShown.value
      },
    },
    escape: {
      handler: () => {
        debugModalShown.value = false
      },
    },
  })
}
</script>
